import React, { useState } from 'react';
import CameraGroup from './CameraGroup';
import CameraData from './CameraData';
import { ToastContainer } from 'react-toastify';

const TABS = ['Camera Groups', 'Cameras'];

function MonitorManage() {
  const [activeTab, setActiveTab] = useState('Camera Groups');

  return (
    <>
      <div className="responsive-box">

        <div className="header-row" style={{ marginBottom: '20px' }}>
          <div className="setting-title" style={{ margin: 0 }}>Monitor Manage</div>
        </div>

        <div style={{ display: 'flex', background: '#f4f4f4', borderRadius: '50px', padding: '4px', gap: '3px', width: 'fit-content', marginBottom: '24px' }}>
          {TABS.map(t => (
            <button
              key={t}
              onClick={() => setActiveTab(t)}
              style={{
                padding: '8px 22px', borderRadius: '50px', border: 'none',
                fontWeight: '700', fontSize: '13px', cursor: 'pointer',
                transition: 'all 0.2s',
                background: activeTab === t ? '#FFAF32' : 'transparent',
                color: activeTab === t ? '#1a1a2e' : '#777',
                boxShadow: activeTab === t ? '0 2px 8px rgba(255,175,50,0.3)' : 'none',
              }}
            >
              {t === 'Cameras' ? '📷 Cameras' : '📁 Camera Groups'}
            </button>
          ))}
        </div>

        {activeTab === 'Camera Groups' ? <CameraGroup /> : <CameraData />}

      </div>

      <ToastContainer />
    </>
  );
}

export default MonitorManage;
